export default __webpack_public_path__ + "static/media/Icon_Flexi&comprehensive_motor.6431cd34.png";